// Classes
import { Range } from "../../../../../containers/Filter/classes/filter.classes";

export class AgeReducerState {
  selection?: "Any" | "Specific Age Range";
  value?: Range;

  constructor(selection?: "Any" | "Specific Age Range", value?: Range) {
    this.selection = selection || "Any";
    this.value = value || new Range(13, 40);
  }
}
